import React from 'react';
import HeaderTwo from '../../components/header/HeaderTwo';
import Footer from '../../components/footer/Footer';
import Breadcrumb from './Breadcrumb';
import AboutInner from './AboutInner'
import LatestMatch from './LatestMatch'
import WhatNext from './what-next'
import OurDeployments from './out-deployments';
import OngoingLeagues from './ongoing-leagues';


function BusinessModel() {
  return (
	<>
	<HeaderTwo/>
	<main>
	<Breadcrumb/>
	<AboutInner/>	
	<LatestMatch/>
	<OngoingLeagues/>
	<WhatNext/>
	<OurDeployments/>
	</main>
	<Footer/>
	</>
  )
}

export default BusinessModel
